import { render } from "./X.vue?vue&type=template&id=5df53fe4"
const script = {}
script.render = render

export default script